/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.Filters.CheckboxFilterView = app.Filters.CheckboxView.extend({
    beforeRun: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#checkbox-filter-view');
    },
    run: function (data) {
      if (data.object && data.parent) {
        data.parent.append(
          this.template(data)
        );
        this.setElement(data.parent.find('input:last'));
      }
    }
  });
})();

}.call(window));